import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Intervencion/editIntervencion`, method: 'POST', body: values, token: token})
}
